import axios, { isAxiosError } from "axios";
import { environment } from "../../../../environment";
import { errorLog } from "../../../../logger";
import ValidationError from "../../../ZodError";
import { GoalBasedFinancialPlanProjectionResponse, GoalBasedFinancialPlanProjectionUnderwaterExceptionResponse, } from "../types";
export const url = (goalBasedFinancialPlanId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/financial-planning/goal-based/${goalBasedFinancialPlanId}/projections`
        : `https://middleware.uat.farther.com/financial-planning/goal-based/${goalBasedFinancialPlanId}/projections`;
};
export const getGoalBasedFinancialPlanProjection = async (goalBasedFinancialPlanId, config) => {
    try {
        const { data } = await axios.get(url(goalBasedFinancialPlanId), {
            headers: {
                Authorization: `Bearer ${config.jwt}`,
                Client: config.clientId,
                ...("advisorId" in config && { Advisor: config.advisorId }),
                Version: "20241101",
            },
        });
        const decoded = GoalBasedFinancialPlanProjectionResponse.safeParse(data);
        if (decoded.success) {
            return decoded.data;
        }
        else {
            const errorMessage = `[getGoalBasedFinancialPlanProjection] Could not parse`;
            errorLog(errorMessage, JSON.stringify(decoded.error.issues));
            throw new ValidationError(errorMessage, decoded.error.issues);
        }
    }
    catch (e) {
        if (isAxiosError(e) && e.response?.status === 400) {
            const decoded = GoalBasedFinancialPlanProjectionUnderwaterExceptionResponse.safeParse(e.response.data);
            if (decoded.success) {
                return decoded.data;
            }
            else {
                const errorMessage = `[getGoalBasedFinancialPlanProjection] Could not parse 400 response`;
                errorLog(errorMessage, JSON.stringify(decoded.error.issues));
                throw new ValidationError(errorMessage, decoded.error.issues);
            }
        }
        throw e;
    }
};
//# sourceMappingURL=getGoalBasedFinancialPlanProjection.js.map